<template>
    <form>
        <div class="row">
            <div class="col-lg-9 col-md-9 col-sm-9">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                            <table
                                class="table-bordered table-full-width mb-3"
                                cellpadding="20"
                                v-if="EvaluationForm.isEditable"
                            >
                            
                                <tr>
                                    <td>
                                        {{
                                            $t(
                                                "rapid_response_grant_ev.technical__grid_download"
                                            )
                                        }}
                                    </td>
                                    <td
                                        class="text-center"
                                        colspan="2"
                                    >
                                        <a
                                            :href="downloadFiles[0][$i18n.locale]"
                                            class="ml-2 btn btn-simple btn-primary"
                                        >
                                            {{
                                                $t(
                                                    "small_technical_grants.document_upload__download_template_button_title"
                                                )
                                            }}
                                            <i
                                                class="tim-icons icon-cloud-download-93 ml-2"
                                            ></i>
                                        </a>
                                    </td>
                                </tr>
                            </table>
                        <table
                        class="table-bordered table-full-width"
                            cellpadding="10"
                            v-if="loggedUser.role == 'EVALUATOR'"
                        >
                          <!-- evaluator doc upload-->
                            <tr v-for="(item, index) in EvaluationForm.model.evaluation_docs" :key="'evaluator_'+index" v-if="loggedUser.id == item.created_by_id">
                                <th>
                                    {{
                                            $t(
                                                "medium_grant_cn_ev.evaluator_name_label"
                                            )
                                        }}
                                </th>
                                <td
                                  class="text-center"
                                    colspan="3"
                                >
                                    <!--{{item.evaluator_name}}-->
                                    <textarea
                                        class="form-control mt-5"
                                        :placeholder="$t('general.write_here')"
                                        v-model="item.evaluator_name"
                                    >
                                    </textarea>
                                </td>
                                <th>
                                  Final Score
                                </th>
                                <td
                                    class="text-center"
                                    colspan="1"
                                >
                                    <div class="form-group mb-0 mt-2">
                                        <label for="item.final_score">{{
                                            $t(
                                                "small_technical_grants_ev.technical__final_score"
                                            )
                                        }}</label>
                                        <input
                                            type="text"
                                            name="item.final_score"
                                            v-model="item.final_score"
                                            :disabled="loggedUser.role == 'EVALUATOR' && item.evaluator_name != loggedUser.name"
                                        />
                                    </div>
                                </td>
                                <td
                                    class="text-center"
                                    colspan="3"
                                >
                                    <upload-file
                                        v-model="
                                            EvaluationForm.files.cntechnical['evaluation_docs' + (index+1)]
                                        "
                                        :select-text="
                                            $t(
                                                'medium_grant_ev.esmsc__upload_evaluation'
                                            )
                                        "
                                        :is-evaluation="true"
                                        :file-data="
                                            EvaluationForm.files.cntechnical['evaluation_docs' + (index+1)]
                                        "
                                        :is-editable="EvaluationForm.isEditable"
                                        :size-limit="EvaluationForm.fileSizeLimit"
                                        :section="'cntechnical.evaluation_docs' + (index + 1)"
                                    ></upload-file>
                                </td>
                            </tr>
                        </table>
                        <table
                        class="table-bordered table-full-width"
                            cellpadding="10"
                            v-if="loggedUser.role != 'EVALUATOR'"
                        >
                          <!-- evaluator doc upload-->
                            <tr v-for="(item, index) in EvaluationForm.model.evaluation_docs" :key="'evaluator_'+index">
                                <th>
                                    {{
                                            $t(
                                                "medium_grant_cn_ev.evaluator_name_label"
                                            )
                                        }}
                                </th>
                                <td
                                  class="text-center"
                                    style="min-width: 150px"
                                >
                                    <textarea
                                        class="form-control mt-5"
                                        :placeholder="$t('general.write_here')"
                                        v-model="item.evaluator_name"
                                    >
                                    </textarea>
                                </td>
                                <th>
                                  Final Score
                                </th>
                                <td
                                    class="text-center"
                                    
                                >
                                    <div class="form-group mb-0 mt-2">
                                        <label for="item.final_score">{{
                                            $t(
                                                "small_technical_grants_ev.technical__final_score"
                                            )
                                        }}</label>
                                        <input
                                        style="max-width: 80px"
                                            type="text"
                                            name="item.final_score"
                                            v-model="item.final_score"
                                            :disabled="loggedUser.role == 'EVALUATOR' && item.evaluator_name != loggedUser.name"
                                        />
                                    </div>
                                </td>
                                <td
                                    class="text-center"
                                    colspan="3"
                                >
                                    <upload-file
                                        v-model="
                                            EvaluationForm.files.cntechnical['evaluation_docs' + (index+1)]
                                        "
                                        :select-text="
                                            $t(
                                                'medium_grant_ev.esmsc__upload_evaluation'
                                            )
                                        "
                                        :is-evaluation="true"
                                        :file-data="
                                            EvaluationForm.files.cntechnical['evaluation_docs' + (index+1)]
                                        "
                                        :is-editable="EvaluationForm.isEditable"
                                        :size-limit="EvaluationForm.fileSizeLimit"
                                        :section="'cntechnical.evaluation_docs' + (index + 1)"
                                    ></upload-file>
                                </td>
                            </tr>
                        </table>
                            <base-button
                            v-if="loggedUser.role == 'ADMIN' || loggedUser.role =='REGIONAL_ADMIN'  && EvaluationForm.isEditable"
                            type="primary"
                            @click.native="addNewEvaluator"
                            class="addrow"
                            >
                            <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
                            </base-button>
                    
                    </div>
                    
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3">
                
                        <info-right></info-right>
                    </div>
        </div>
    </form>
</template>
<script>
import { EvaluationForm } from "@/services";
import InfoRight from "./InfoRight";
import ApplicationInfo from "../ApplicationInfo";
import { CommentBox } from "src/components";
import { Select, Option } from "element-ui";

export default {
    components: {
        ApplicationInfo,
        InfoRight,
        CommentBox,
        loggedUser:{},
        [Select.name]: Select,
        [Option.name]: Option
    },
    data() {
        return {
            EvaluationForm,
            technichaltemplateName : '',
            downloadFiles: [
                {
                    en: '/files/en/MG/CN/Region/'+EvaluationForm.application.region_id+'/'+this.technichaltemplateName+'.docx',
                    fr: '/files/fr/MG/CN/Region/'+EvaluationForm.application.region_id+'/'+this.technichaltemplateName+'.docx'
                }
            ]
        };
    },
    created() {
      this.loggedUser = this.$store.getters['Auth/loggedUser']; 
    },
    beforeCreate() {
        if (!EvaluationForm.files.cntechnical) {
            EvaluationForm.files.cntechnical = {};
        }
    },
    mounted(){
      let vm =this;
      //Add new row to evaluation grid
      if(vm.EvaluationForm.isEditable){
      if (!vm.EvaluationForm.model.evaluation_docs) {
          vm.EvaluationForm.model.evaluation_docs = [];
          vm.EvaluationForm.model.evaluation_docs.push(
              {evaluator_name : this.loggedUser.name,
              final_score : 0,
              created_by_name : this.loggedUser.name
              ,created_by_id : this.loggedUser.id});
            this.$forceUpdate();
      }
      else{
            let fg = 0;
            for (let i = 0; i < vm.EvaluationForm.model.evaluation_docs.length; i++) {
              if(this.loggedUser.id == vm.EvaluationForm.model.evaluation_docs[i].created_by_id){
                  fg = 1;
              }
            }
            if(fg == 0){
              vm.EvaluationForm.model.evaluation_docs.push(
                  {evaluator_name : this.loggedUser.name,
                  final_score : 0,
                  created_by_name : this.loggedUser.name,
                  created_by_id : this.loggedUser.id});
              this.$forceUpdate();
            }
      }
      }
      //Regionwise template name
    if(vm.EvaluationForm.application.region_id == 1){
        vm.technichaltemplateName = 'MG_Pacific_Concept_technical_evaluation_grid'
    }
    else if(vm.EvaluationForm.application.region_id == 3 || vm.EvaluationForm.application.region_id == 4){
        vm.technichaltemplateName = 'MG_WCA_Concept_technical_evaluation_grid_EN'
    }
    else if(vm.EvaluationForm.application.region_id == 5 || vm.EvaluationForm.application.region_id == 6){
        vm.technichaltemplateName = 'MG_ESA_Concept_technical_evaluation_grid'
    }
    vm.downloadFiles = [{
                    en: '/files/en/MG/CN/Region/'+this.EvaluationForm.application.region_id+'/'+this.technichaltemplateName+'.docx',
                    fr: '/files/fr/MG/CN/Region/'+this.EvaluationForm.application.region_id+'/'+this.technichaltemplateName+'.docx'
                }]

    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            return this.$validator.validateAll().then(res => {
                this.$emit("on-validated", res, this.model);
                return res;
            });
        },
        addNewEvaluator()
        {
            /*if (!EvaluationForm.model.evaluation_docs)
            {
            EvaluationForm.model.evaluation_docs = [];
            }*/

            EvaluationForm.model.evaluation_docs.push(
                {evaluator_name : '',
                final_score : 0,
                created_by_name : this.loggedUser.name,
                created_by_id : this.loggedUser.id});
            this.$forceUpdate();
        },
    }
};
</script>
<style scoped>
textarea {
    resize: vertical !important;
}
</style>
